import { createFileRoute } from '@tanstack/react-router';
import { PainelGerencial } from '@/features/painel-gerencial/page/PainelGerencial';

export const Route = createFileRoute('/a/painel-gerencial/')({
    component: PainelGerencial,
});
